import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    documentId: z.string(),
  }),
  response: z.void(),
};
